<template>
  <div>
    <div class="our-store">
      <div class="bread">
        <p v-html="'HOME &nbsp; / &nbsp; BESPOKE'"></p>
      </div>
      <h2>STORE</h2>
      <div class="store_container">
        <div class="store_img col-md-6">
          <img :src="storeImg" alt="">
        </div>
        <div class="storeText col-md-6">
          <h4>New York City</h4>
          <p>
          Corporate Headquarters 25 West 26th St.,5th Floor
          </p>
          <h6>TEL： ＋81(0)3-5726-9810</h6>
          <a href="#">
          <h5>Email: shop@emmalee.com</h5>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storeImg from '@/assets/pc/store/store.png'
export default {
  data () {
    return {
      storeImg
    }
  }
}
</script>
